import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/audit-log")({
  component: AuditLog,
});

function AuditLog() {
  return (
    <div>
      <div className="label-card">Audit log</div>
      <h1 className="mt-1 font-display text-3xl font-semibold">
        Every admin action, logged.
      </h1>
      <div className="mt-8 card-ledger p-8 text-center text-ink-soft">
        Chronological audit stream mounts here once{" "}
        <code className="font-mono text-xs">/admin/audit-log</code> is live.
      </div>
    </div>
  );
}
